<template>
  <v-overlay
    v-model="props.loading"
    class="align-center justify-center"
  >
    <v-progress-circular
      color="lime"
      bg-color="blue-grey-darken-2"
      :size="128"
      :width="5"
      indeterminate
    ></v-progress-circular>
  </v-overlay>
      
  <v-overlay
    v-model="props.loadingchair"
    class="align-center justify-center"
  >
    <v-progress-circular
      color="lime"
      bg-color="blue-grey-darken-2"
      :size="48"
      :width="3"
      indeterminate
    ></v-progress-circular>
  </v-overlay>
</template>
<script setup>
  const props = defineProps({
    loading: Boolean,
    loadingchair: Boolean,
  });
</script>